import AccountView from './AccountView';
import ErrorDisplay from '../../../components/ErrorDisplay';
import Loading from '../../../components/Loading';
import { setDocumentTitle } from '../../../utils/documentTitle';
import { useCurrentClient } from '../../../hooks/useCurrentClient';
import { useEffect } from 'react';

const AccountController = () => {
	useEffect(setDocumentTitle('Konto')); // eslint-disable-line react-hooks/exhaustive-deps
	
	const [client, clientLoading, clientError] = useCurrentClient()

	if (clientLoading) return <Loading/>;
	if (clientError) return <ErrorDisplay error={clientError}/>;
	
	return <AccountView client={client!}/>
};

export default AccountController;
